import { Flex, Button } from '@backyard-ui/core'

interface NewChatButtonProps {
  onClick: () => void
  threads: Array<{ isOpenThread: boolean }>
}

function NewChatButton({ onClick, threads }: NewChatButtonProps) {
  const hasOpenConversation = threads.some(
    thread => thread.isOpenThread === true
  )

  if (hasOpenConversation) {
    return null
  }

  return (
    <Flex justify="flex-end" className="p-5">
      <Button
        appearance="success"
        radius="lg"
        variant="solid"
        size="sm"
        onClick={onClick}>
        Iniciar nova conversa
      </Button>
    </Flex>
  )
}

export default NewChatButton
